import { render, staticRenderFns } from "./VipOrder.vue?vue&type=template&id=0ba3262e&scoped=true"
import script from "./VipOrder.vue?vue&type=script&lang=js"
export * from "./VipOrder.vue?vue&type=script&lang=js"
import style0 from "./VipOrder.vue?vue&type=style&index=0&id=0ba3262e&prod&scoped=true&lang=css"
import style1 from "./VipOrder.vue?vue&type=style&index=1&id=0ba3262e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba3262e",
  null
  
)

export default component.exports